/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";
import { Trash, PencilSimpleLine } from "@phosphor-icons/react";
import api from "../../utils/api";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import permissions from "../Permissions/permissions1";

const QuestionType = () => {
  const [fetchedData, setFetchedData] = useState([]);
  const [show, setShow] = useState(false);
  const [questionType, setQuestionType] = useState("");
  const [options, setOptions] = useState("");
  const [ID, setID] = useState(null); // ID will be used for editing e

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10); // Customize the number of items per page
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(false);
  const TableLoader = ({ rows = 10, columns = 10 }) => (
    <tbody>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <tr key={rowIndex}>
          {Array.from({ length: columns }).map((_, colIndex) => (
            <td key={colIndex} className="text-center">
              <div
                style={{
                  height: "20px",
                  backgroundColor: "#e0e0e0",
                  borderRadius: "20px",
                  width: colIndex === 0 ? "20%" : "40%", // Adjust width for variety
                }}
              ></div>
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  );

  async function fetchData(page = 1) {
    setLoading(true);
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getQuestionTypeDetails";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);
      fd.append("page", page);
      fd.append("limit", itemsPerPage);

      const response = await api.post("questionType/questionTypeCurl", fd);
      // console.log("Response data:", response.data);

      if (
        response.data &&
        Array.isArray(response.data.getQuestionTypeDetails)
      ) {
        setFetchedData(response.data.getQuestionTypeDetails);
        setCurrentPage(page);
        setTotalItems(response.data.totalPages * itemsPerPage); // Derive totalItems from totalPages
      } else {
        setFetchedData([]);
        setTotalItems(0);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setFetchedData([]);
    } finally {
      setLoading(false);
    }
  }

  async function handleSubmit(e) {
    e.preventDefault();

    const loggedInUser = localStorage.getItem("loggedInUser");
    const token = localStorage.getItem("authToken");
    const programType = ID ? "updateQuestionType" : "addQuestionType";

    // console.log("Form Data being submitted:", {
    //   questionType,
    //   options,
    // });

    const fd = new FormData();
    fd.append("programType", programType);
    fd.append("loggedInUser", loggedInUser);
    fd.append("token", token);
    fd.append("questionType", questionType);
    fd.append("noOfOptions", options);

    // Only append 'id' if it exists (for updating)
    if (ID) {
      fd.append("id", ID);
    }

    // Log FormData to check its contents before sending
    for (let pair of fd.entries()) {
      console.log(pair[0] + ": " + pair[1]);
    }

    try {
      const response = await api.post("questionType/questionTypeCurl", fd);
      // console.log(response.data);

      if (response.data.status === true) {
        toast.success(response.data.data); // Display message in toaster

        
        fetchData(); // Refresh the data after submitting the form
        setShow(false); // Close the modal
        setQuestionType(""); // Reset module name input
        setOptions("");
      } else {
        toast.error(response.data.data);
      }

      setID(null); // Reset the ID after the action
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  }

  async function handleDelete(id) {
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "deleteQuestionType";

      const fd = new FormData();
      fd.append("programType", programType);
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("id", id);

      const response = await api.post("questionType/questionTypeCurl", fd);
      // console.log("Delete response:", response);
      if (response.data && response.data.message) {
        // console.log(response.data.message);
        toast.success("Question Type deleted successfully");
      } else {
        toast.success("Question Type deleted successfully");
        console.error("Failed to delete the module. Response:", response);
      }

      // Refresh the data after deletion
      fetchData(); // This will update the list of courses
    } catch (error) {
      console.error("Error deleting module:", error);
    }
  }

  // Open the modal for adding a new module
  const handleShowAdd = () => {
    setQuestionType("");
    setOptions("");
    setID(null); // No ID for new module
    setShow(true);
  };

  // Open the modal for editing an existing module
  async function handleShowEdit(question) {
    // console.log(question.id);

    const loggedInUser = localStorage.getItem("loggedInUser");
    const token = localStorage.getItem("authToken");
    const programType = "getDetailsForUpdate";

    const fd = new FormData();
    fd.append("programType", programType);
    fd.append("loggedInUser", loggedInUser);
    fd.append("token", token);
    fd.append("id", question.id);

    try {
      const response = await api.post("questionType/questionTypeCurl", fd);
      // console.log("Response from API:", response);

      if (response.data && response.data.getQuestionTypeDetails) {
        const questionTypeDetails = response.data.getQuestionTypeDetails[0]; // Assuming the response is an array of chapter details
        // Prefill the form fields
        setQuestionType(questionTypeDetails.questionType);
        setOptions(questionTypeDetails.options);
        setID(questionTypeDetails.id); // Set ID for editing
        setShow(true); // Show the modal
      }
    } catch (error) {
      console.error("Error fetching chapter details:", error);
    }
  }

  // Close the modal
  const handleClose = () => {
    setShow(false);
    setQuestionType(""); // Reset the form data
    setID(null); // Reset ID
  };

  // Pagination logic
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      fetchData(page);
    }
  };
  // Fetch data when the component mounts
  useEffect(() => {
    fetchData();
  }, []);

  const mystyle = {
    marginTop: "25px",
    display: "flex",
    justifyContent: "space-between",
  };

  const mystyle1 = {
    marginTop: "15px",
  };

  return (
    <div className="dashboard-body">
      <div className="breadcrumb-with-buttons mb-24 flex-between flex-wrap gap-8">
        <div className="breadcrumb mb-24">
          <ul className="flex-align gap-4">
            <li>
              <Link
                to="/"
                className="text-gray-200 fw-normal text-15 hover-text-main-600"
              >
                Home
              </Link>
            </li>
            <li>
              <span className="text-gray-500 fw-normal d-flex">
                <i className="ph ph-caret-right"></i>
              </span>
            </li>
            <li>
              <span className="text-main-600 fw-normal text-15">
                Question Type
              </span>
            </li>
          </ul>
        </div>

        <div className="flex-align gap-8 flex-wrap">
          <div className="flex-align gap-8 flex-wrap">
            {/* <div class="position-relative text-gray-500 flex-align gap-4 text-13">
              <span class="text-inherit">Sort by: </span>
              <div class="flex-align text-gray-500 text-13 border border-gray-100 rounded-4 ps-20 focus-border-main-600 bg-white">
                <span class="text-lg">
                  <i class="ph ph-funnel-simple"></i>
                </span>
                <select class="form-control  mb-5   border-0 text-inherit rounded-4 text-center">
                  <option value="1" selected>
                    Popular
                  </option>
                  <option value="1">Latest</option>
                  <option value="1">Trending</option>
                  <option value="1">Matches</option>
                </select>
              </div>
            </div>
            <div class="flex-align text-gray-500 text-13 border border-gray-100 rounded-4 ps-20 focus-border-main-600 bg-white">
              <span class="text-lg">
                <i class="ph ph-layout"></i>
              </span>
              <select
                class="form-control mb-5 border-0 text-inherit rounded-4 text-center"
                id="exportOptions"
              >
                <option value="" selected disabled>
                  Export
                </option>
                <option value="csv">CSV</option>
                <option value="json">JSON</option>
              </select>
            </div> */}
            {permissions.addQuestionType && (
              <button
                onClick={handleShowAdd}
                className="btn btn-lg btn-main mt-0"
              >
                Add Question Type
              </button>
            )}
          </div>
        </div>
      </div>
      {/* Subject Table */}
      <div className="card mt-24">
        <div
          className="card-header  table-responsive"
          style={{ padding: "10px" }}
        >
          <table id="subjectTable" className="table table-striped dataTable">
            <thead>
              <tr>
                <th className="h5 text-gray-300" scope="col">
                  ID
                </th>
                <th className="h5 text-gray-300" scope="col">
                  Question Type Name
                </th>
                <th className="h5 text-gray-300" scope="col">
                  No. of options
                </th>
                <th className="h5 text-gray-300" scope="col">
                  Action
                </th>
              </tr>
            </thead>
            {loading ? (
              <TableLoader rows={4} columns={4} /> // Show custom loader
            ) : (
              <tbody>
                {permissions.questionTypeList ? (
                  <>
                    {fetchedData.map((question, index) => (
                      <tr key={question.id}>
                        <td className="h6 mb-0 fw-medium text-gray-300">
                          {(currentPage - 1) * itemsPerPage + index + 1}
                        </td>
                        <td className="h6 mb-0 fw-medium text-gray-300">
                          {question.questionType}
                        </td>
                        <td className="h6 mb-0 fw-medium text-gray-300">
                          {question.options}
                        </td>

                        <td className="g-2">
                          {permissions.editQuestionType && (
                            <button onClick={() => handleShowEdit(question)}>
                              <PencilSimpleLine size={22} color="#00945b" />
                            </button>
                          )}
                          &nbsp; &nbsp;
                          {permissions.deleteQuestionType && (
                            <button onClick={() => handleDelete(question.id)}>
                              <Trash size={22} color="#c70000" />
                            </button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </>
                ) : (
                  <tr>
                    <td colSpan="3" className="text-center text-danger">
                      Permission Denied !
                    </td>
                  </tr>
                )}
              </tbody>
            )}
          </table>
        </div>
        {/* Pagination */}
        <div className="card-footer flex-between flex-wrap">
          <span>
            {fetchedData.length > 0
              ? `Showing ${(currentPage - 1) * itemsPerPage + 1} to ${
                  (currentPage - 1) * itemsPerPage + fetchedData.length
                } `
              : "No entries to show"}
          </span>
          <ul className="pagination">
            {Array.from({ length: totalPages }, (_, index) => (
              <li
                key={index}
                className={`page-item ${
                  currentPage === index + 1 ? "active" : ""
                }`}
              >
                <button
                  className="page-link h-44 w-44 flex-center text-15 rounded-8 fw-medium"
                  onClick={() => handlePageChange(index + 1)}
                >
                  {index + 1}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <ToastContainer />

      {/* Modal for adding/editing modules */}
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {ID ? "Edit Question Type" : "Add New Question Type"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit} id="question-type-form">
            <div className="mb-3">
              <label htmlFor="questionType" className="form-label mb-8 h6">
                Question Type
              </label>
              <input
                type="text"
                className="form-control fw-medium "
                placeholder="Enter New Question Type"
                id="questionType"
                name="questionType"
                value={questionType}
                onChange={(e) => setQuestionType(e.target.value)}
                required
              />
            </div>
            <div className="" style={mystyle1}>
              <label htmlFor="options" className="form-label mb-8 h6">
                Options
              </label>
              <input
                type="text"
                className="form-control fw-medium "
                placeholder="Enter No. of options"
                id="options"
                name="options"
                value={options}
                onChange={(e) => setOptions(e.target.value)}
                required
              />
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="btn btn-outline-main bg-main-100 border-main-100 text-main-600 rounded-pill py-9"
            variant="secondary"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <button
            form="question-type-form"
            variant="primary"
            type="submit"
            className="btn btn-main rounded-pill py-9"
          >
            {ID ? "Update Question Type" : "Add Question Type"}
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default QuestionType;
